import { motion } from "framer-motion";

const STEPS = [
    {
        n: "01",
        t: "Order",
        d: "Book your panel through TRT Plus pathology partners — athlete-specific markers, not commercial default panels.",
    },
    {
        n: "02",
        t: "Interpret",
        d: "Automated OCR extraction, optimized reference ranges, weighted multi-marker scoring.",
    },
    {
        n: "03",
        t: "Dial in",
        d: "The Testimator™ anchors your baseline to your actual Total T and predicts levels across any protocol.",
    },
    {
        n: "04",
        t: "Adjust",
        d: "Update your protocol, track it, and close the loop with dose titration, reminders, inventory, and rotation planning.",
    },
];

export default function Framework() {
    return (
        <section
            id="framework"
            data-testid="framework-section"
            className="relative py-24 lg:py-32 bg-black overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20 items-start">
                    <div className="lg:sticky lg:top-28">
                        <div className="eyebrow mb-6">
                            <span className="dot" /> The Framework
                        </div>
                        <h2 className="font-display font-bold clamp-h2 text-white">
                            Not a logging app.
                            <br />A complete{" "}
                            <span className="blue-glow">framework.</span>
                        </h2>
                        <p className="mt-6 text-white/65 text-base lg:text-lg max-w-md leading-relaxed">
                            From ordering the right bloodwork through TRT Plus
                            pathology partners, to interpreting your results,
                            dialling in with the Testimator™, and adjusting
                            your protocol accordingly — every feature exists to
                            close that loop.
                        </p>
                    </div>

                    <div className="relative">
                        <div className="absolute left-6 lg:left-8 top-3 bottom-3 w-px bg-gradient-to-b from-[#2ba6e0]/60 via-[#2ba6e0]/20 to-transparent" />
                        <div className="flex flex-col gap-6">
                            {STEPS.map((s, i) => (
                                <motion.div
                                    key={s.n}
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true, amount: 0.4 }}
                                    transition={{ duration: 0.5, delay: i * 0.08 }}
                                    className="tile relative pl-16 lg:pl-20 pr-6 py-7"
                                    data-testid={`framework-step-${s.n}`}
                                >
                                    <span className="absolute left-0 top-6 w-12 lg:w-14 h-12 lg:h-14 rounded-full bg-black border border-[#2ba6e0]/50 flex items-center justify-center font-mono text-[#49bef5] text-sm">
                                        {s.n}
                                    </span>
                                    <h3 className="font-display text-2xl font-bold text-white mb-1.5">
                                        {s.t}
                                    </h3>
                                    <p className="text-white/60 text-sm lg:text-[15px] leading-relaxed">
                                        {s.d}
                                    </p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
